import React from "react";
import { Helmet } from 'react-helmet';
// import Slider from "../../components/slider/Slider";
// import YatraHero from "../yatra/YatraHero";
import ClientTestimonials from "../../components/testimonials/ClientTestimonials";
import WeekendTourPreview from "../../components/tours/WeekendTourPreview";
// import PilgrimageCarousel from "../../components/pilgrimage/PilgrimageCarousel";

import PopularTourCarousel from "../../components/carousel/PopularTourCarousel";
// import { nepalDhamTours } from "../../components/carousel/NepalDhamCarouselData";
// import { pilgrimageTours } from "../../components/carousel/PilgrimageCarouselData";

import ContactForm from "../../components/contact/ContactForm";
import HomeFaqs from "../../components/faqs/HomeFaqs";
import BookletSection from "../../components/booklets/BookletSection";
import JyotirlingaMiniCards from "../yatra/JyotirlingaMiniCards";
// import YatraExpertsSection from "../yatra/YatraExpertsSection";
import Herosection from "../../components/hero/Herosection";
import BookingSearch from "../../components/hero/BookingSearch";
import OurExpertise from "../../components/home/OurExpertise";
import OurPartners from "../../components/home/OurPartners";
import BlogSection from "../../components/BlogSection";
// import TopBar from "../../components/TopBar";


import InstaMoments from "../../components/home/InstaMoments";


const Home = () => {
  return (
    <>
      <Helmet>
        <title>Khajuraho Tour Packages, Taxi & Travel Services | Khajuraho Routes</title>
        <meta name="description" content="Explore Khajuraho with private tour packages, temple sightseeing, Panna safari tours, Orchha trips, taxi and car rental services. Plan your Central India journey with Khajuraho Routes." />
        <meta name="keywords" content="Khajuraho tour packages, Khajuraho taxi service, Panna National Park tour from Khajuraho, Khajuraho temple tour, Khajuraho to Orchha tour, Madhya Pradesh tour packages" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://khajurahoroutes.com/" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://khajurahoroutes.com/" />
        <meta property="og:site_name" content="Khajuraho Routes" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:title" content="Khajuraho Tour Packages, Taxi & Travel Services | Khajuraho Routes" />
        <meta property="og:description" content="Explore Khajuraho with private tour packages, temple sightseeing, Panna safari tours, Orchha trips, taxi and car rental services. Plan your Central India journey with Khajuraho Routes." />
        <meta property="og:image" content="https://khajurahoroutes.com/android-chrome-512x512.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Khajuraho Tour Packages, Taxi & Travel Services | Khajuraho Routes" />
        <meta name="twitter:description" content="Explore Khajuraho with private tour packages, temple sightseeing, Panna safari tours, Orchha trips, taxi and car rental services. Plan your Central India journey with Khajuraho Routes." />
        <meta name="twitter:image" content="https://khajurahoroutes.com/android-chrome-512x512.png" />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "TravelAgency",
              "@id": "https://khajurahoroutes.com/#travelagency",
              "name": "Khajuraho Routes",
              "url": "https://khajurahoroutes.com/",
              "logo": "https://khajurahoroutes.com/logo.png",
              "image": "https://khajurahoroutes.com/android-chrome-512x512.png",
              "description": "Khajuraho tour packages, Panna safari tours, Orchha trips, taxi and hotel booking in Khajuraho, Madhya Pradesh.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Opp. Shilpgram, Near Poddar Chowk",
                "addressLocality": "Khajuraho",
                "addressRegion": "Madhya Pradesh",
                "postalCode": "471606",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 24.8318,
                "longitude": 79.9199
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.instagram.com/routeskhajuraho/"
              ]
            }
          `}
        </script>
      </Helmet>
      {/* <Slider /> */}
      {/* <TopBar/> */}
      <Herosection/>
      <BookingSearch />
      <OurExpertise />
      {/* <JyotirlingaMiniCards /> */}
      <WeekendTourPreview />
      <InstaMoments />
      {/* <YatraExpertsSection /> */}
      <BookletSection />
      <HomeFaqs />
      <ClientTestimonials />
      <OurPartners />
      <BlogSection />

    </>
  );
};

export default Home;
